import { homeApis } from './apis';
import { useStoreStore } from '@/stores/store-store';
import type { Attendance } from '@/types/attendance';
import type { EmployeeType } from '@nailsupply/review-swagger/employees';
import type { StoreAppointmentConfigType } from '@nailsupply/review-swagger/store-appointment-config';
import type { StoreDetailResponseType } from '@nailsupply/review-swagger/stores';
import { ref } from 'vue';

export const useHome = () => {
  const homeService = homeApis();
  const employeeList = ref<EmployeeType[]>([]);
  const todayAttendances = ref<Attendance[]>([]);
  const loading = ref(false);

  const { setStoreDetail, setStoreAppointmentConfig, setStorePaymentConfig, setStoreTurnConfig, setHomeRoute } = useStoreStore();

  const fetchHomeData = async () => {
    const response = await homeService.getHomeData();

    if (response?.data) {
      employeeList.value = response.data.activeEmployees;
      // SDK `employeesCheckedInToday` (Attendance) có avatar nullable; local
      // `Attendance` type khai báo avatar: string — cast để khớp, dữ liệu runtime giống nhau.
      todayAttendances.value = response.data.employeesCheckedInToday as Attendance[];
    }
    return response?.data ?? null;
  };

  const fetchDataGlobal = async () => {
    try {
      loading.value = true;
      const response = await homeService.getDataGlobal();
      if (response?.data) {
        setStoreDetail(response.data.storeDetail as StoreDetailResponseType);
        setStoreAppointmentConfig(response.data.storeConfig.storeAppointmentConfig as StoreAppointmentConfigType);
        setStorePaymentConfig(response.data.storeConfig.storePaymentsConfig);
        if (response.data.storeConfig.storeTurnConfig) {
          setStoreTurnConfig(response.data.storeConfig.storeTurnConfig);
        }
        setHomeRoute(response.data.storeConfig.homeRoute);
      }
    } catch (error) {
      console.error('Error fetching data global:', error);
    } finally {
      loading.value = false;
    }
  };

  return {
    fetchHomeData,
    fetchDataGlobal,
    employeeList,
    todayAttendances,
    loading
  }
}
